<div class="container">
  <app-swatch
    [color]="testimonial.color"
    [texture]="testimonial.texture"
    [textureColor]="testimonial.textureColor"
    [svgViewBox]="testimonial.textureSvgViewBox"
  >
    <div class="inner-wrapper">
      <div class="background">
        <h5>{{ testimonial.company | uppercase }}</h5>
        <mat-divider class="divider custom"></mat-divider>
        <p class="testimonial">{{ testimonial.testimonial }}</p>
        <p class="handle">{{ testimonial.handle | uppercase }}</p>
      </div>
    </div>
  </app-swatch>
</div>
